module.exports = __webpack_public_path__ + "static/media/ajustes_active.99f3e8e9.svg";